import { render } from "./SassyPage.vue?vue&type=template&id=686e69b2&scoped=true"
import script from "./SassyPage.vue?vue&type=script&lang=js"
export * from "./SassyPage.vue?vue&type=script&lang=js"

import "./SassyPage.vue?vue&type=style&index=0&id=686e69b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686e69b2"]])

export default __exports__